import { useAddressSliceActions } from './useAddressSliceActions'
import { AddressSliceKey } from './useAddressState'

// устанавливает ошибку для текущего адреса
export const useSetErrorAddress = (addressKey: AddressSliceKey = 'default') => {
  const { setErrorMessage, setIsError, setIsValidAddress } =
    useAddressSliceActions(addressKey)

  return (_: string, massage: string) => {
    setIsError(true)
    setErrorMessage(massage)
    setIsValidAddress(false)
  }
}
